import './Array';
import './Number';
import './Object';
import './React';
import './String';



// WEBPACK FOOTER //
// ./src/Extensions/index.ts